import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';

export const buildCommand = (services: CommandServices) =>
  createCommand('build').action(async (_, command) => {
    const { runCommand } = await import('./render-command.js');
    const { build } = await import('../build.js');

    await runCommand(command, services, build);
  });
